import { Calculator } from "lucide-react";

const ROWS = [
  {
    label: "Formule Essentielle",
    price: 290,
    deduction: 87,
    real: 203,
  },
  {
    label: "Formule Sérénité",
    price: 490,
    deduction: 147,
    real: 343,
  },
];

export default function Deductibility() {
  return (
    <section
      id="deductibilite"
      data-testid="deductibility-section"
      className="bg-[#F5F0EB] py-20 sm:py-28 lg:py-32"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 reveal">
            <span className="inline-flex items-center gap-2 text-[#E8611A] font-semibold text-sm tracking-widest uppercase mb-4">
              <Calculator className="w-4 h-4" />
              Argument fiscal
            </span>
            <h2 className="font-display font-extrabold text-[#1A2E4A] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              En vrai, combien ça vous coûte&nbsp;?
            </h2>
            <p className="mt-6 text-[#2D2D2D]/80 text-base sm:text-lg leading-relaxed">
              Notre service est une charge professionnelle déductible de vos
              impôts. Ce n&apos;est pas un luxe — c&apos;est un investissement qui se
              finance en partie tout seul.
            </p>
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="bg-white border border-black/5 rounded-sm overflow-hidden shadow-sm">
              <div className="grid grid-cols-12 px-5 sm:px-7 py-4 bg-[#1A2E4A] text-white text-xs sm:text-sm font-semibold uppercase tracking-wider">
                <div className="col-span-6">Formule</div>
                <div className="col-span-2 text-right">Prix</div>
                <div className="col-span-2 text-right hidden sm:block">Déduction*</div>
                <div className="col-span-4 sm:col-span-2 text-right">Coût réel</div>
              </div>
              {ROWS.map((r, i) => (
                <div
                  key={i}
                  data-testid={`deduction-row-${i}`}
                  className="grid grid-cols-12 px-5 sm:px-7 py-5 sm:py-6 border-t border-black/5 items-baseline"
                >
                  <div className="col-span-6 font-display font-bold text-[#1A2E4A] text-base sm:text-lg">
                    {r.label}
                  </div>
                  <div className="col-span-2 text-right text-[#2D2D2D] font-medium tabular-nums">
                    {r.price}€
                  </div>
                  <div className="col-span-2 text-right text-[#8A8A8A] hidden sm:block tabular-nums">
                    −{r.deduction}€
                  </div>
                  <div className="col-span-4 sm:col-span-2 text-right">
                    <span className="font-display font-extrabold text-[#E8611A] text-xl sm:text-2xl tabular-nums">
                      ~{r.real}€
                    </span>
                    <div className="text-[10px] sm:text-xs text-[#8A8A8A]">
                      /mois
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <p className="mt-6 text-[#2D2D2D]/85 text-base leading-relaxed">
              Pour <span className="font-semibold text-[#1A2E4A]">moins de 7€ par jour</span>,
              vous ne touchez plus à votre gestion administrative. Pendant ce
              temps, vous facturez vos heures à votre taux habituel.
            </p>

            <p className="mt-5 text-[#8A8A8A] text-xs leading-relaxed">
              *Estimation à titre indicatif basée sur une tranche marginale d&apos;imposition
              de 30%. Consultez votre comptable pour votre situation personnelle.
              Valable pour les artisans imposés au réel (BIC/BNC).
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
